import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { getField } from 'src/common/helper';
import PrintConsentFormService from './printQuote/PrintConsentFormService';

type PrintConsentFormProps = {
  parts: any[];
  items: any[];
};

const PrintConsentForm: React.FC<PrintConsentFormProps> = (props) => {

  return (
    <Box sx={{
      width: '100%',
      '@media print': {
        p: '4mm'
      }
    }}>
      <Box sx={{ p: '4mm' }}>
        <Typography sx={{ ...PrintConsentFormService.fontText, ...PrintConsentFormService.paddingX }}>
          リゾナスフェイスクリニック東京
        </Typography>
        <Stack spacing={'2.8mm'}>
          <Box display={'flex'} justifyContent={'center'}>
            <Typography sx={{ ...PrintConsentFormService.fontText, fontSize: '28px' }}>
              同意書
            </Typography>
          </Box>

          <Box sx={{ ...PrintConsentFormService.groupBox, p: '2.4mm 2mm', minHeight: '28mm' }}>
            <Typography sx={{ ...PrintConsentFormService.fontText }}>
              お申し込み内容
            </Typography>
            {props.items.map((item: any, index: number) => (
              <Box key={index} display={'inline-flex'}>
                {(item['surgery']['surgery'] && PrintConsentFormService.canDisplaySurgery(item['surgery']['surgery'])) && (
                  <>
                    <Box width={'14px'} />
                    <Typography sx={{ ...PrintConsentFormService.fontText }} mr={'1.2mm'}>
                      {item['surgery']['surgery'] ? getField(item.surgery, 'surgery') + (getField(item, 'note', '') ? '（' + getField(item, 'note') + '）' : '') : ''}
                    </Typography>
                  </>
                )}
              </Box>
            ))}
          </Box>

          <Box>
            <Typography sx={{ ...PrintConsentFormService.fontText }}>
              ※下記の項目をご確認いただき、
              <Typography component='label' sx={{ ...PrintConsentFormService.fontText, color: 'red' }}>
                □へのチェックならびにご署名
              </Typography>
              をお願いいたします。
            </Typography>
          </Box>

          <Box>
            <Box display={'flex'} justifyContent={'row'}>
              <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                {'１．'}
              </Typography>
              <Box>
                <Typography sx={{ ...PrintConsentFormService.fontText }}>
                  {'当院では、治療経過の確認のためにカルテ用の写真撮影を行っています。写真撮影を拒否されますと、治療過の確認が十分にできないため、施術効果の問い合わせや施術の影響による合併症(皮膚トラブル・神経症状など）が発生した場合などについて、対応致しかねますので、ご了承ください。'}
                </Typography>
                <Typography sx={{ ...PrintConsentFormService.fontText, ...PrintConsentFormService.spaceRow }}>
                  □ 上記について、理解しました
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box>
            <Box display={'flex'} justifyContent={'row'}>
              <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                {'2．'}
              </Typography>
              <Box>
                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                  {'今回お申し込みいただく内容は、他院修正ではありませんか？他院修正の場合、別途費用が必要となる場合が\nあります。他院修正であることを術前に申告せず、後日他院修正であることが判明した場合、その時点で修正\n代金をご請求させていただく場合があります。'}
                </Typography>
                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText, fontWeight: '700' }}>
                  {'※フェイスリフトの修正手術には、フェイスリフトの施術部位に施術歴がある方は対象となります。\n   →糸リフト・フェイスリフト・頬顎の脂肪吸引等も含まれます。'}
                </Typography>
                <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceRow }}>
                  <Typography sx={{ ...PrintConsentFormService.fontText, mr: '10.6mm' }}>
                    □ 初回手術です
                  </Typography>
                  <Typography sx={{ ...PrintConsentFormService.fontText }}>
                    □ 修正手術です
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box display={'flex'} justifyContent={'row'}>
            <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
              {'3．'}
            </Typography>

            <Box>
              <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                {'施術中・施術後は適切な対応が必要となります。当院での管理が難しいと判断した場合は総合病院などに搬送\nし加療する 事があります。その場合、以下にご記入頂く電話番号に連絡します。'}
              </Typography>
              <Box>
                <Typography sx={{ ...PrintConsentFormService.fontText, ...PrintConsentFormService.spaceRow20px }}>
                  ・必須
                  <Typography component='label' sx={{ ...PrintConsentFormService.fontText, color: 'red' }}>
                    ＜ご家族＞
                  </Typography>
                  ※日本語で会話ができる方をご記入下さい
                </Typography>
              </Box>

              <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceCol }}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'お名前: '}
                  </Typography>
                  <Box sx={{ width: '100mm', borderBottom: '1px solid black' }} />
                </Box>
                <Box display={'flex'} justifyContent={'row'}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'続柄: '}
                  </Typography>
                  <Box sx={{ width: '46.6875mm', borderBottom: '1px solid black' }} />
                </Box>
              </Box>

              <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceCol }}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'ご住所: '}
                  </Typography>
                  <Box sx={{ width: '100mm', borderBottom: '1px solid black' }} />
                </Box>
                <Box display={'flex'} justifyContent={'row'}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'電話番号: '}
                  </Typography>
                  <Box sx={{ width: '39.6875mm', borderBottom: '1px solid black' }} />
                </Box>
              </Box>

              <Box sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                  {'・任意＜連絡のつく方＞　※日本語で会話ができる方をご記入下さい'}
                </Typography>
              </Box>

              <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceCol }}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'お名前: '}
                  </Typography>
                  <Box sx={{ width: '100mm', borderBottom: '1px solid black' }} />
                </Box>
                <Box display={'flex'} justifyContent={'row'}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'続柄: '}
                  </Typography>
                  <Box sx={{ width: '46.6875mm', borderBottom: '1px solid black' }} />
                </Box>
              </Box>

              <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceCol }}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'ご住所: '}
                  </Typography>
                  <Box sx={{ width: '100mm', borderBottom: '1px solid black' }} />
                </Box>
                <Box display={'flex'} justifyContent={'row'}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'電話番号: '}
                  </Typography>
                  <Box sx={{ width: '39.6875mm', borderBottom: '1px solid black' }} />
                </Box>
              </Box>

              <Box sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                  {'□  施術方法・効果、禁忌事項、副作用など'}
                </Typography>

                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText, ...PrintConsentFormService.spaceRow }}>
                  {'□  麻酔の種類や禁忌事項など（麻酔を受けられる方のみにご説明を致します）'}
                </Typography>

                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText, ...PrintConsentFormService.spaceRow }}>
                  {'□  予約やキャンセルの方法など'}
                </Typography>

                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText, ...PrintConsentFormService.spaceRow }}>
                  {'□  術前シュミレーションは結果を予測するものではありません\n   術前のイメージ共有のため使用するものであることをご理解ください'}
                </Typography>
              </Box>

              <Box sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                  {'施術について十分な説明を受けました。また疑問点がある場合には医師に質問し、説明を受けました。\n以上について理解した上で、施術を受けることに同意して署名致します。'}
                </Typography>
              </Box>

              <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                  {'記入日:'}
                </Typography>

                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText, ml: '21.166mm' }}>
                  {'年'}
                </Typography>

                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText, ml: '7.9375mm' }}>
                  {'月'}
                </Typography>

                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText, ml: '7.9375mm' }}>
                  {'日'}
                </Typography>
              </Box>

              <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceCol }}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'ご住所: '}
                  </Typography>
                  <Box sx={{ width: '100mm', borderBottom: '1px solid black' }} />
                </Box>
                <Box display={'flex'} justifyContent={'row'}>
                  <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                    {'電話番号: '}
                  </Typography>
                  <Box sx={{ width: '39.6875mm', borderBottom: '1px solid black' }} />
                </Box>
              </Box>

              <Box display={'flex'} justifyContent={'row'} sx={{ ...PrintConsentFormService.spaceRow20px }}>
                <Typography component={'pre'} sx={{ ...PrintConsentFormService.fontText }}>
                  {'本人署名: '}
                </Typography>
                <Box sx={{ width: '96mm', borderBottom: '1px solid black' }} />
              </Box>

            </Box>
          </Box>
        </Stack>
      </Box >
    </Box >
  );
}

export default PrintConsentForm;
